// hooks/useTopicCounts.js
import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collectionGroup, getDocs } from "firebase/firestore";

const useTopicCounts = () => {
  const [counts, setCounts] = useState({
    Environmental: 0,
    Social: 0,
    Governance: 0,
  });
  const [topics, setTopics] = useState({
    Environmental: [],
    Social: [],
    Governance: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const snapshot = await getDocs(collectionGroup(db, "Topics"));

        let environmental = [];
        let social = [];
        let governance = [];

        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.Pillar === "Environmental")
            environmental.push(data.Topic || doc.id);
          else if (data.Pillar === "Social") social.push(data.Topic || doc.id);
          else if (data.Pillar === "Governance")
            governance.push(data.Topic || doc.id);
        });

        setTopics({
          Environmental: environmental,
          Social: social,
          Governance: governance,
        });

        setCounts({
          Environmental: environmental.length,
          Social: social.length,
          Governance: governance.length,
        });
      } catch (error) {
        console.error("Error fetching topic counts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return { counts, topics, loading };
};

export default useTopicCounts;
